module.exports = __webpack_public_path__ + "img/icon3.1a638fe9.svg";